import { Flex } from 'antd';
import * as React from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { paths } from '../common';

type LogoTypeType = 'full' | 'short';

type LogoStyleType = {
    type?: LogoTypeType;
};
type LogoProps = {
    type?: LogoTypeType;
    margin?: string;
};

const LogoStyle = styled.a<LogoStyleType>`
    display: block;
    background: transparent url(${(props) => (props.type === 'full' ? '/logo-full.png' : '/logo-short.svg')}) no-repeat
        0 0;
    text-indent: -9999px;
    margin: 0 auto;
    width: ${(props) => (props.type === 'full' ? '200px' : '33px')};
    height: ${(props) => (props.type === 'full' ? '28px' : '33px')};
    //background-size: cover;
    background-position-y: bottom;
`;

export const Logo: React.FC<LogoProps> = ({ type, margin }) => {
    const history = useNavigate();
    const location = useLocation();

    const onClick = useCallback(() => {
        history(paths.MAIN);
    }, [location, history]);

    const logo = (
        <LogoStyle href={'#'} type={type} onClick={onClick}>
            SiteMax
        </LogoStyle>
    );

    return (
        <Flex style={{ margin: margin }} className="logo" align={'center'}>
            {type === 'full' ? (
                logo
            ) : (
                <div style={{ borderRadius: 28, padding: 5, backgroundColor: '#08172B' }}>{logo}</div>
            )}
        </Flex>
    );
};
